import apiClient from '@/services/http/client'

export interface StudioOption {
  id: number
  name: string
}

export interface StudiosResponse {
  data?: {
    studios?: StudioOption[]
  }
}

export const fetchUserStudios = async () => {
  const response = await apiClient.get<StudiosResponse>('/api/v1/me/studios')
  const studios = response.data.data?.studios
  return Array.isArray(studios) ? studios : []
}
